import { AssetActionTypes } from './asset.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addAssetSuccess: null,
    addAssetError: null,
    addAssetReqStatus: '',
    assetListSuccess: null,
    assetListError: null,
    assetDetailSuccess: null,
    assetDetailError: null,
    assignAssetSuccess: null,
    assignAssetError: null,
    assignAssetReqStatus: '',
    unAssignAssetSuccess: null,
    unAssignAssetError: null,
    unAssignAssetReqStatus: '',
    updateAssetStatusSuccess: null,
    updateAssetStatusError: null,
    updateAssetStatusReqStatus: ''
}

const assetReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AssetActionTypes.ADD_ASSET_REQUEST_SUCCESS:
            return {
                ...state,
                addAssetSuccess: action.payload,
                addAssetError: null,
                addAssetReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AssetActionTypes.ADD_ASSET_REQUEST_ERROR:
            return {
                ...state,
                addAssetSuccess: null,
                addAssetError: action.payload,
                addAssetReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AssetActionTypes.ADD_ASSET_REQUEST_STATUS:
            return {
                ...state,
                addAssetReqStatus: ''
            }
        case AssetActionTypes.ASSET_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                assetListSuccess: action.payload,
                assetListError: null
            }
        case AssetActionTypes.ASSET_LIST_REQUEST_ERROR:
            return {
                ...state,
                assetListSuccess: null,
                assetListError: action.payload
            }
        case AssetActionTypes.ASSET_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                assetDetailSuccess: action.payload,
                assetDetailError: null
            }
        case AssetActionTypes.ASSET_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                assetDetailSuccess: null,
                assetDetailError: action.payload
            }
        case AssetActionTypes.ASSIGN_ASSET_REQUEST_SUCCESS:
            return {
                ...state,
                assignAssetSuccess: action.payload,
                assignAssetError: null,
                assignAssetReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AssetActionTypes.ASSIGN_ASSET_REQUEST_ERROR:
            return {
                ...state,
                assignAssetSuccess: null,
                assignAssetError: action.payload,
                assignAssetReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AssetActionTypes.ASSIGN_ASSET_REQUEST_STATUS:
            return {
                ...state,
                assignAssetReqStatus: ''
            }
        case AssetActionTypes.UN_ASSIGN_ASSET_REQUEST_SUCCESS:
            return {
                ...state,
                unAssignAssetSuccess: action.payload,
                unAssignAssetError: null,
                unAssignAssetReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AssetActionTypes.UN_ASSIGN_ASSET_REQUEST_ERROR:
            return {
                ...state,
                unAssignAssetSuccess: null,
                unAssignAssetError: action.payload,
                unAssignAssetReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AssetActionTypes.UN_ASSIGN_ASSET_REQUEST_STATUS:
            return {
                ...state,
                unAssignAssetReqStatus: ''
            }
        case AssetActionTypes.UPDATE_ASSET_STATUS_REQUEST_SUCCESS:
            return {
                ...state,
                updateAssetStatusSuccess: action.payload,
                updateAssetStatusError: null,
                updateAssetStatusReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case AssetActionTypes.UPDATE_ASSET_STATUS_REQUEST_ERROR:
            return {
                ...state,
                updateAssetStatusSuccess: null,
                updateAssetStatusError: action.payload,
                updateAssetStatusReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case AssetActionTypes.UPDATE_ASSET_STATUS_REQUEST_STATUS:
            return {
                ...state,
                updateAssetStatusReqStatus: ''
            }
        case AssetActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default assetReducer